import clsx from 'clsx'
import { Icon } from '@iconify/react'

import styles from './Card.module.css'
import { ReportType } from '@pepper/utils/src/types/seo'

type Props = {
  type: 'success' | 'error'
  title: string
  subTitle?: string
  children?: React.ReactNode
  icon?: React.ReactNode
  reportType?: ReportType
}

const icons = {
  GAP: {
    success: (
      <Icon
        icon="lucide:circle-check"
        width={24}
        height={24}
        color="var(--color-green-500)"
      />
    ),
    error: <Icon icon="lucide:x-circle" width={24} height={24} color="red" />,
  },
  CRR: <Icon icon="lucide:lightbulb" width={16} height={16} />,
}

const Card = ({
  type,
  title,
  subTitle,
  children,
  icon,
  reportType = 'CRR',
}: Props) => {
  const isGapReport = reportType === 'GAP'

  return (
    <div
      className={clsx(isGapReport ? styles.gapReportWrapper : styles.wrapper, {
        [styles.greenBorder]: type === 'success' && !isGapReport,
      })}
    >
      <div
        className={clsx(
          styles.header,
          !isGapReport ? styles[type] : styles.defaultHeader
        )}
      >
        <div className={styles.titleWrapper}>
          {!isGapReport ? (
            <span className={clsx(styles.dot, styles[type])}>•</span>
          ) : null}

          {icon ?? (
            <>
              {reportType === 'CRR' && icons['CRR']}
              {reportType === 'GAP' &&
                (type === 'success'
                  ? icons[reportType].success
                  : icons[reportType].error)}
            </>
          )}

          <span className={styles.title}>
            {title}
            {!!subTitle && ':'}
          </span>
        </div>
        <div className={styles.subTitle}>{subTitle}</div>
      </div>
      {children ? (
        <div className={clsx(styles.body, isGapReport && styles.bodyText)}>
          {children}
        </div>
      ) : null}
    </div>
  )
}

export default Card
